module.exports = __webpack_public_path__ + "img/banner-1.7eda4f58.png";